export const MOVE_ENUM : string [] = [
  "(No Move)",
  "Pound",
  "Karate Chop",
  "Double Slap",
  "Comet Punch",
  "Mega Punch",
  "Pay Day",
  "Fire Punch",
  "Ice Punch",
  "Thunder Punch",
  "Scratch",
  "Vise Grip",
  "Guillotine",
  "Razor Wind",
  "Swords Dance",
  "Cut",
  "Gust",
  "Wing Attack",
  "Whirlwind",
  "Fly",
  "Bind",
  "Slam",
  "Vine Whip",
  "Stomp",
  "Double Kick",
  "Mega Kick",
  "Jump Kick",
  "Rolling Kick",
  "Sand Attack",
  "Headbutt",
  "Horn Attack",
  "Fury Attack",
  "Horn Drill",
  "Tackle",
  "Body Slam",
  "Wrap",
  "Take Down",
  "Thrash",
  "Double-Edge",
  "Tail Whip",
  "Poison Sting",
  "Twineedle",
  "Pin Missile",
  "Leer",
  "Bite",
  "Growl",
  "Roar",
  "Sing",
  "Supersonic",
  "Sonic Boom",
  "Disable",
  "Acid",
  "Ember",
  "Flamethrower",
  "Mist",
  "Water Gun",
  "Hydro Pump",
  "Surf",
  "Ice Beam",
  "Blizzard",
  "Psybeam",
  "Bubble Beam",
  "Aurora Beam",
  "Hyper Beam",
  "Peck",
  "Drill Peck",
  "Submission",
  "Low Kick",
  "Counter",
  "Seismic Toss",
  "Strength",
  "Absorb",
  "Mega Drain",
  "Leech Seed",
  "Growth",
  "Razor Leaf",
  "Solar Beam",
  "Poison Powder",
  "Stun Spore",
  "Sleep Powder",
  "Petal Dance",
  "String Shot",
  "Dragon Rage",
  "Fire Spin",
  "Thunder Shock",
  "Thunderbolt",
  "Thunder Wave",
  "Thunder",
  "Rock Throw",
  "Earthquake",
  "Fissure",
  "Dig",
  "Toxic",
  "Confusion",
  "Psychic",
  "Hypnosis",
  "Meditate",
  "Agility",
  "Quick Attack",
  "Rage",
  "Teleport",
  "Night Shade",
  "Mimic",
  "Screech",
  "Double Team",
  "Recover",
  "Harden",
  "Minimize",
  "Smokescreen",
  "Confuse Ray",
  "Withdraw",
  "Defense Curl",
  "Barrier",
  "Light Screen",
  "Haze",
  "Reflect",
  "Focus Energy",
  "Bide",
  "Metronome",
  "Mirror Move",
  "Self-Destruct",
  "Egg Bomb",
  "Lick",
  "Smog",
  "Sludge",
  "Bone Club",
  "Fire Blast",
  "Waterfall",
  "Clamp",
  "Swift",
  "Skull Bash",
  "Spike Cannon",
  "Constrict",
  "Amnesia",
  "Kinesis",
  "Soft-Boiled",
  "High Jump Kick",
  "Glare",
  "Dream Eater",
  "Poison Gas",
  "Barrage",
  "Leech Life",
  "Lovely Kiss",
  "Sky Attack",
  "Transform",
  "Bubble",
  "Dizzy Punch",
  "Spore",
  "Flash",
  "Psywave",
  "Splash",
  "Acid Armor",
  "Crabhammer",
  "Explosion",
  "Fury Swipes",
  "Bonemerang",
  "Rest",
  "Rock Slide",
  "Hyper Fang",
  "Sharpen",
  "Conversion",
  "Tri Attack",
  "Super Fang",
  "Slash",
  "Substitute",
  "Struggle",
  "Sketch",
  "Triple Kick",
  "Thief",
  "Spider Web",
  "Mind Reader",
  "Nightmare",
  "Flame Wheel",
  "Snore",
  "Curse",
  "Flail",
  "Conversion 2",
  "Aeroblast",
  "Cotton Spore",
  "Reversal",
  "Spite",
  "Powder Snow",
  "Protect",
  "Mach Punch",
  "Scary Face",
  "Feint Attack",
  "Sweet Kiss",
  "Belly Drum",
  "Sludge Bomb",
  "Mud-Slap",
  "Octazooka",
  "Spikes",
  "Zap Cannon",
  "Foresight",
  "Destiny Bond",
  "Perish Song",
  "Icy Wind",
  "Detect",
  "Bone Rush",
  "Lock-On",
  "Outrage",
  "Sandstorm",
  "Giga Drain",
  "Endure",
  "Charm",
  "Rollout",
  "False Swipe",
  "Swagger",
  "Milk Drink",
  "Spark",
  "Fury Cutter",
  "Steel Wing",
  "Mean Look",
  "Attract",
  "Sleep Talk",
  "Heal Bell",
  "Return",
  "Present",
  "Frustration",
  "Safeguard",
  "Pain Split",
  "Sacred Fire",
  "Magnitude",
  "Dynamic Punch",
  "Megahorn",
  "Dragon Breath",
  "Baton Pass",
  "Encore",
  "Pursuit",
  "Rapid Spin",
  "Sweet Scent",
  "Iron Tail",
  "Metal Claw",
  "Vital Throw",
  "Morning Sun",
  "Synthesis",
  "Moonlight",
  "Hidden Power",
  "Cross Chop",
  "Twister",
  "Rain Dance",
  "Sunny Day",
  "Crunch",
  "Mirror Coat",
  "Psych Up",
  "Extreme Speed",
  "Ancient Power",
  "Shadow Ball",
  "Future Sight",
  "Rock Smash",
  "Whirlpool",
  "Beat Up",
  "Fake Out",
  "Uproar",
  "Stockpile",
  "Spit Up",
  "Swallow",
  "Heat Wave",
  "Hail",
  "Torment",
  "Flatter",
  "Will-O-Wisp",
  "Memento",
  "Facade",
  "Focus Punch",
  "Smelling Salts",
  "Follow Me",
  "Nature Power",
  "Charge",
  "Taunt",
  "Helping Hand",
  "Trick",
  "Role Play",
  "Wish",
  "Assist",
  "Ingrain",
  "Superpower",
  "Magic Coat",
  "Recycle",
  "Revenge",
  "Brick Break",
  "Yawn",
  "Knock Off",
  "Endeavor",
  "Eruption",
  "Skill Swap",
  "Imprison",
  "Refresh",
  "Grudge",
  "Snatch",
  "Secret Power",
  "Dive",
  "Arm Thrust",
  "Camouflage",
  "Tail Glow",
  "Luster Purge",
  "Mist Ball",
  "Feather Dance",
  "Teeter Dance",
  "Blaze Kick",
  "Mud Sport",
  "Ice Ball",
  "Needle Arm",
  "Slack Off",
  "Hyper Voice",
  "Poison Fang",
  "Crush Claw",
  "Blast Burn",
  "Hydro Cannon",
  "Meteor Mash",
  "Astonish",
  "Weather Ball",
  "Aromatherapy",
  "Fake Tears",
  "Air Cutter",
  "Overheat",
  "Odor Sleuth",
  "Rock Tomb",
  "Silver Wind",
  "Metal Sound",
  "Grass Whistle",
  "Tickle",
  "Cosmic Power",
  "Water Spout",
  "Signal Beam",
  "Shadow Punch",
  "Extrasensory",
  "Sky Uppercut",
  "Sand Tomb",
  "Sheer Cold",
  "Muddy Water",
  "Bullet Seed",
  "Aerial Ace",
  "Icicle Spear",
  "Iron Defense",
  "Block",
  "Howl",
  "Dragon Claw",
  "Frenzy Plant",
  "Bulk Up",
  "Bounce",
  "Mud Shot",
  "Poison Tail",
  "Covet",
  "Volt Tackle",
  "Magical Leaf",
  "Water Sport",
  "Calm Mind",
  "Leaf Blade",
  "Dragon Dance",
  "Rock Blast",
  "Shock Wave",
  "Water Pulse",
  "Doom Desire",
  "Psycho Boost",
  "Roost",
  "Gravity",
  "Miracle Eye",
  "Wake-Up Slap",
  "Hammer Arm",
  "Gyro Ball",
  "Healing Wish",
  "Brine",
  "Natural Gift",
  "Feint",
  "Pluck",
  "Tailwind",
  "Acupressure",
  "Metal Burst",
  "U-turn",
  "Close Combat",
  "Payback",
  "Assurance",
  "Embargo",
  "Fling",
  "Psycho Shift",
  "Trump Card",
  "Heal Block",
  "Wring Out",
  "Power Trick",
  "Gastro Acid",
  "Lucky Chant",
  "Me First",
  "Copycat",
  "Power Swap",
  "Guard Swap",
  "Punishment",
  "Last Resort",
  "Worry Seed",
  "Sucker Punch",
  "Toxic Spikes",
  "Heart Swap",
  "Aqua Ring",
  "Magnet Rise",
  "Flare Blitz",
  "Force Palm",
  "Aura Sphere",
  "Rock Polish",
  "Poison Jab",
  "Dark Pulse",
  "Night Slash",
  "Aqua Tail",
  "Seed Bomb",
  "Air Slash",
  "X-Scissor",
  "Bug Buzz",
  "Dragon Pulse",
  "Dragon Rush",
  "Power Gem",
  "Drain Punch",
  "Vacuum Wave",
  "Focus Blast",
  "Energy Ball",
  "Brave Bird",
  "Earth Power",
  "Switcheroo",
  "Giga Impact",
  "Nasty Plot",
  "Bullet Punch",
  "Avalanche",
  "Ice Shard",
  "Shadow Claw",
  "Thunder Fang",
  "Ice Fang",
  "Fire Fang",
  "Shadow Sneak",
  "Mud Bomb",
  "Psycho Cut",
  "Zen Headbutt",
  "Mirror Shot",
  "Flash Cannon",
  "Rock Climb",
  "Defog",
  "Trick Room",
  "Draco Meteor",
  "Discharge",
  "Lava Plume",
  "Leaf Storm",
  "Power Whip",
  "Rock Wrecker",
  "Cross Poison",
  "Gunk Shot",
  "Iron Head",
  "Magnet Bomb",
  "Stone Edge",
  "Captivate",
  "Stealth Rock",
  "Grass Knot",
  "Chatter",
  "Judgment",
  "Bug Bite",
  "Charge Beam",
  "Wood Hammer",
  "Aqua Jet",
  "Attack Order",
  "Defend Order",
  "Heal Order",
  "Head Smash",
  "Double Hit",
  "Roar of Time",
  "Spacial Rend",
  "Lunar Dance",
  "Crush Grip",
  "Magma Storm",
  "Dark Void",
  "Seed Flare",
  "Ominous Wind",
  "Shadow Force",
  "Hone Claws",
  "Wide Guard",
  "Guard Split",
  "Power Split",
  "Wonder Room",
  "Psyshock",
  "Venoshock",
  "Autotomize",
  "Rage Powder",
  "Telekinesis",
  "Magic Room",
  "Smack Down",
  "Storm Throw",
  "Flame Burst",
  "Sludge Wave",
  "Quiver Dance",
  "Heavy Slam",
  "Synchronoise",
  "Electro Ball",
  "Soak",
  "Flame Charge",
  "Coil",
  "Low Sweep",
  "Acid Spray",
  "Foul Play",
  "Simple Beam",
  "Entrainment",
  "After You",
  "Round",
  "Echoed Voice",
  "Chip Away",
  "Clear Smog",
  "Stored Power",
  "Quick Guard",
  "Ally Switch",
  "Scald",
  "Shell Smash",
  "Heal Pulse",
  "Hex",
  "Sky Drop",
  "Shift Gear",
  "Circle Throw",
  "Incinerate",
  "Quash",
  "Acrobatics",
  "Reflect Type",
  "Retaliate",
  "Final Gambit",
  "Bestow",
  "Inferno",
  "Water Pledge",
  "Fire Pledge",
  "Grass Pledge",
  "Volt Switch",
  "Struggle Bug",
  "Bulldoze",
  "Frost Breath",
  "Dragon Tail",
  "Work Up",
  "Electroweb",
  "Wild Charge",
  "Drill Run",
  "Dual Chop",
  "Heart Stamp",
  "Horn Leech",
  "Sacred Sword",
  "Razor Shell",
  "Heat Crash",
  "Leaf Tornado",
  "Steamroller",
  "Cotton Guard",
  "Night Daze",
  "Psystrike",
  "Tail Slap",
  "Hurricane",
  "Head Charge",
  "Gear Grind",
  "Searing Shot",
  "Techno Blast",
  "Relic Song",
  "Secret Sword",
  "Glaciate",
  "Bolt Strike",
  "Blue Flare",
  "Fiery Dance",
  "Freeze Shock",
  "Ice Burn",
  "Snarl",
  "Icicle Crash",
  "V-create",
  "Fusion Flare",
  "Fusion Bolt",
  "Flying Press",
  "Mat Block",
  "Belch",
  "Rototiller",
  "Sticky Web",
  "Fell Stinger",
  "Phantom Force",
  "Trick-or-Treat",
  "Noble Roar",
  "Ion Deluge",
  "Parabolic Charge",
  "Forest’s Curse",
  "Petal Blizzard",
  "Freeze-Dry",
  "Disarming Voice",
  "Parting Shot",
  "Topsy-Turvy",
  "Draining Kiss",
  "Crafty Shield",
  "Flower Shield",
  "Grassy Terrain",
  "Misty Terrain",
  "Electrify",
  "Play Rough",
  "Fairy Wind",
  "Moonblast",
  "Boomburst",
  "Fairy Lock",
  "King’s Shield",
  "Play Nice",
  "Confide",
  "Diamond Storm",
  "Steam Eruption",
  "Hyperspace Hole",
  "Water Shuriken",
  "Mystical Fire",
  "Spiky Shield",
  "Aromatic Mist",
  "Eerie Impulse",
  "Venom Drench",
  "Powder",
  "Geomancy",
  "Magnetic Flux",
  "Happy Hour",
  "Electric Terrain",
  "Dazzling Gleam",
  "Celebrate",
  "Hold Hands",
  "Baby-Doll Eyes",
  "Nuzzle",
  "Hold Back",
  "Infestation",
  "Power-Up Punch",
  "Oblivion Wing",
  "Thousand Arrows",
  "Thousand Waves",
  "Land’s Wrath",
  "Light of Ruin",
  "Origin Pulse",
  "Precipice Blades",
  "Dragon Ascent",
  "Hyperspace Fury",
  "Breakneck Blitz",
  "Breakneck Blitz",
  "All-Out Pummeling",
  "All-Out Pummeling",
  "Supersonic Skystrike",
  "Supersonic Skystrike",
  "Acid Downpour",
  "Acid Downpour",
  "Tectonic Rage",
  "Tectonic Rage",
  "Continental Crush",
  "Continental Crush",
  "Savage Spin-Out",
  "Savage Spin-Out",
  "Never-Ending Nightmare",
  "Never-Ending Nightmare",
  "Corkscrew Crash",
  "Corkscrew Crash",
  "Inferno Overdrive",
  "Inferno Overdrive",
  "Hydro Vortex",
  "Hydro Vortex",
  "Bloom Doom",
  "Bloom Doom",
  "Gigavolt Havoc",
  "Gigavolt Havoc",
  "Shattered Psyche",
  "Shattered Psyche",
  "Subzero Slammer",
  "Subzero Slammer",
  "Devastating Drake",
  "Devastating Drake",
  "Black Hole Eclipse",
  "Black Hole Eclipse",
  "Twinkle Tackle",
  "Twinkle Tackle",
  "Catastropika",
  "Shore Up",
  "First Impression",
  "Baneful Bunker",
  "Spirit Shackle",
  "Darkest Lariat",
  "Sparkling Aria",
  "Ice Hammer",
  "Floral Healing",
  "High Horsepower",
  "Strength Sap",
  "Solar Blade",
  "Leafage",
  "Spotlight",
  "Toxic Thread",
  "Laser Focus",
  "Gear Up",
  "Throat Chop",
  "Pollen Puff",
  "Anchor Shot",
  "Psychic Terrain",
  "Lunge",
  "Fire Lash",
  "Power Trip",
  "Burn Up",
  "Speed Swap",
  "Smart Strike",
  "Purify",
  "Revelation Dance",
  "Core Enforcer",
  "Trop Kick",
  "Instruct",
  "Beak Blast",
  "Clanging Scales",
  "Dragon Hammer",
  "Brutal Swing",
  "Aurora Veil",
  "Sinister Arrow Raid",
  "Malicious Moonsault",
  "Oceanic Operetta",
  "Guardian of Alola",
  "Soul-Stealing 7-Star Strike",
  "Stoked Sparksurfer",
  "Pulverizing Pancake",
  "Extreme Evoboost",
  "Genesis Supernova",
  "Shell Trap",
  "Fleur Cannon",
  "Psychic Fangs",
  "Stomping Tantrum",
  "Shadow Bone",
  "Accelerock",
  "Liquidation",
  "Prismatic Laser",
  "Spectral Thief",
  "Sunsteel Strike",
  "Moongeist Beam",
  "Tearful Look",
  "Zing Zap",
  "Nature’s Madness",
  "Multi-Attack",
  "10,000,000 Volt Thunderbolt",
  "Mind Blown",
  "Plasma Fists",
  "Photon Geyser",
  "Light That Burns the Sky",
  "Searing Sunraze Smash",
  "Menacing Moonraze Maelstrom",
  "Let’s Snuggle Forever",
  "Splintered Stormshards",
  "Clangorous Soulblaze",
  "Zippy Zap",
  "Splishy Splash",
  "Floaty Fall",
  "Pika Papow",
  "Bouncy Bubble",
  "Buzzy Buzz",
  "Sizzly Slide",
  "Glitzy Glow",
  "Baddy Bad",
  "Sappy Seed",
  "Freezy Frost",
  "Sparkly Swirl",
  "Veevee Volley",
  "Double Iron Bash",
  "Max Guard",
  "Dynamax Cannon",
  "Snipe Shot",
  "Jaw Lock",
  "Stuff Cheeks",
  "No Retreat",
  "Tar Shot",
  "Magic Powder",
  "Dragon Darts",
  "Teatime",
  "Octolock",
  "Bolt Beak",
  "Fishious Rend",
  "Court Change",
  "Max Flare",
  "Max Flutterby",
  "Max Lightning",
  "Max Strike",
  "Max Knuckle",
  "Max Phantasm",
  "Max Hailstorm",
  "Max Ooze",
  "Max Geyser",
  "Max Airstream",
  "Max Starfall",
  "Max Wyrmwind",
  "Max Mindstorm",
  "Max Rockfall",
  "Max Quake",
  "Max Darkness",
  "Max Overgrowth",
  "Max Steelspike",
  "Clangorous Soul",
  "Body Press",
  "Decorate",
  "Drum Beating",
  "Snap Trap",
  "Pyro Ball",
  "Behemoth Blade",
  "Behemoth Bash",
  "Aura Wheel",
  "Breaking Swipe",
  "Branch Poke",
  "Overdrive",
  "Apple Acid",
  "Grav Apple",
  "Spirit Break",
  "Strange Steam",
  "Life Dew",
  "Obstruct",
  "False Surrender",
  "Meteor Assault",
  "Eternabeam",
  "Steel Beam",
  "Expanding Force",
  "Steel Roller",
  "Scale Shot",
  "Meteor Beam",
  "Shell Side Arm",
  "Misty Explosion",
  "Grassy Glide",
  "Rising Voltage",
  "Terrain Pulse",
  "Skitter Smack",
  "Burning Jealousy",
  "Lash Out",
  "Poltergeist",
  "Corrosive Gas",
  "Coaching",
  "Flip Turn",
  "Triple Axel",
  "Dual Wingbeat",
  "Scorching Sands",
  "Jungle Healing",
  "Wicked Blow",
  "Surging Strikes",
  "Thunder Cage",
  "Dragon Energy",
  "Freezing Glare",
  "Fiery Wrath",
  "Thunderous Kick",
  "Glacial Lance",
  "Astral Barrage",
  "Eerie Spell"
]

export default MOVE_ENUM;